module.exports = __webpack_public_path__ + "static/media/gal4.aa7c76c7.JPG";